import React from 'react';
import styled from 'styled-components';
import { FaCheck, FaTimes } from 'react-icons/fa';

const QuestionContainer = styled.div`
  background-color: white;
  border-radius: 15px;
  padding: 2rem;
  margin: 2rem auto;
  max-width: 800px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
`;

const QuestionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`;

const QuestionNumber = styled.span`
  background-color: #4169E1;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-weight: bold;
`;

const QuestionText = styled.h2`
  font-size: 1.4rem;
  margin-bottom: 1.5rem;
  line-height: 1.5;
`;

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Option = styled.button`
  background-color: ${props => 
    props.selected && props.correct ? '#32CD32' : 
    props.selected && !props.correct ? '#FF4757' : 
    props.correct && props.showAnswer ? '#32CD32' : 
    'white'};
  color: ${props => 
    (props.selected || (props.correct && props.showAnswer)) ? 'white' : '#2C3E50'};
  border: 2px solid ${props => 
    props.selected && props.correct ? '#32CD32' : 
    props.selected && !props.correct ? '#FF4757' : 
    props.correct && props.showAnswer ? '#32CD32' : 
    '#E0E0E0'};
  border-radius: 10px;
  padding: 1rem;
  text-align: left;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: ${props => props.answered ? 'inherit' : '#F0F8FF'};
    transform: ${props => props.answered ? 'none' : 'translateY(-2px)'};
    box-shadow: ${props => props.answered ? 'none' : '0 4px 8px rgba(0, 0, 0, 0.1)'};
  }
  
  &:disabled {
    cursor: default;
  }
`;

const OptionText = styled.span`
  flex: 1;
`;

const IconContainer = styled.span`
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FeedbackContainer = styled.div`
  margin-top: 1.5rem;
  padding: 1rem;
  border-radius: 10px;
  background-color: ${props => props.correct ? 'rgba(50, 205, 50, 0.1)' : 'rgba(255, 71, 87, 0.1)'};
  border-left: 5px solid ${props => props.correct ? '#32CD32' : '#FF4757'};
`;

const NextButton = styled.button`
  background-color: #FF9500;
  color: white;
  padding: 0.8rem 2rem;
  border-radius: 25px;
  margin-top: 1.5rem;
  align-self: flex-end;
  font-weight: bold;
  
  &:hover {
    background-color: #FF8000;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
`;

const MultipleChoiceQuestion = ({ question, options, correctAnswer, feedbackCorrect, feedbackIncorrect, questionNumber, totalQuestions, onAnswer, onNext, answered, selectedOption }) => {
  const showAnswer = answered !== null;
  const isCorrect = answered === correctAnswer;
  
  const handleOptionClick = (index) => {
    if (answered === null) {
      onAnswer(index);
    }
  };

  return (
    <QuestionContainer>
      <QuestionHeader>
        <QuestionNumber>Ερώτηση {questionNumber}/{totalQuestions}</QuestionNumber>
      </QuestionHeader>
      
      <QuestionText>{question}</QuestionText>
      
      <OptionsContainer>
        {options.map((option, index) => (
          <Option 
            key={index}
            onClick={() => handleOptionClick(index)}
            selected={selectedOption === index}
            correct={index === correctAnswer}
            showAnswer={showAnswer}
            answered={answered !== null}
            disabled={answered !== null}
          >
            <OptionText>{option}</OptionText>
            {showAnswer && index === selectedOption && isCorrect && (
              <IconContainer>
                <FaCheck color="#FFFFFF" size={20} />
              </IconContainer>
            )}
            {showAnswer && index === selectedOption && !isCorrect && (
              <IconContainer>
                <FaTimes color="#FFFFFF" size={20} />
              </IconContainer>
            )}
            {showAnswer && index === correctAnswer && selectedOption !== correctAnswer && (
              <IconContainer>
                <FaCheck color="#FFFFFF" size={20} />
              </IconContainer>
            )}
          </Option>
        ))}
      </OptionsContainer>
      
      {showAnswer && (
        <FeedbackContainer correct={isCorrect}>
          {isCorrect ? feedbackCorrect : feedbackIncorrect}
        </FeedbackContainer>
      )}
      
      {showAnswer && (
        <ButtonContainer>
          <NextButton onClick={onNext}>Επόμενη Ερώτηση</NextButton>
        </ButtonContainer>
      )}
    </QuestionContainer>
  );
};

export default MultipleChoiceQuestion;
